<template>
	<div class="zzl-container">
		<div class="zzl-content">
			<div class="zzl-title">管理</div>

		</div>
	</div>
</template>

<script>
  export default {
    name: "Home",
    methods:{
    }
  }
</script>

<style lang="scss" scoped>

</style>
